import { createFileRoute, redirect } from '@tanstack/react-router'
import { AnalyticsScreen } from '@/features/hr-reports/analytics-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/analytics')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: AnalyticsScreen,
})
